module.exports = __webpack_public_path__ + "static/img-opinion-3aa70c52bed3ce7bb9a7f669a6d933e6.png";